import { render, staticRenderFns } from "./cap_alerts.vue?vue&type=template&id=4777548f"
import script from "./cap_alerts.vue?vue&type=script&lang=js"
export * from "./cap_alerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports